/**
 * Link danh mục đẹp: /danh-muc/nhan-nu/ thay vì /danh-muc/NHANNU/.
 * API vẫn dùng mã (code); web chỉ đổi phần hiện trên URL.
 * Danh mục mới chưa có trong bảng → vẫn dùng mã như cũ (không lỗi). Muốn link đẹp thì thêm 1 dòng ở đây.
 * LƯU Ý: đã lên prod thì đừng đổi slug (Google đã index); nếu buộc đổi, giữ slug cũ trong OLD_SLUGS.
 */
export const CATEGORY_SLUGS: Record<string, string> = {
  MOI: 'moi',
  ALL: 'trang-suc-kim-cuong-tu-nhien',
  NHANNU: 'nhan-nu',
  BONGTAI: 'bong-tai',
  MAT_DAY: 'mat-day-chuyen',
  VONGTAY: 'vong-tay',
  LACTAY: 'lac-tay',
  NHANDA_NGOCTRAI: 'nhan-da-quy-ngoc-trai',
  SPNAM: 'trang-suc-nam',
  NGOCTRAI: 'ngoc-trai-da-quy',
  SPTHUE: 'trang-suc-cho-thue',
  DICHVUKYGUI: 'san-pham-ky-gui',
  BSTSHESEA: 'dong-gia',
};

/** slug cũ (nếu sau này đổi) → mã, để link cũ vẫn chạy và tự chuyển sang slug mới */
const OLD_SLUGS: Record<string, string> = { 'tat-ca-san-pham': 'ALL' };

const SLUG_TO_CODE: Record<string, string> = Object.entries(CATEGORY_SLUGS).reduce(
  (acc, [code, slug]) => ({ ...acc, [slug]: code }),
  { ...OLD_SLUGS } as Record<string, string>
);

/**
 * mã → phần hiện trên URL. Ưu tiên slug nhập trong admin (có trong danh sách danh mục từ API),
 * rồi tới bảng dự phòng ở trên, cuối cùng giữ nguyên mã.
 */
export const categorySlug = (
  code?: string | null,
  categories?: Array<{ code?: string; slug?: string | null }> | null
): string => {
  const c = String(code ?? '');
  const fromApi = categories?.find((x) => x?.code?.toUpperCase() === c.toUpperCase())?.slug;
  return fromApi || CATEGORY_SLUGS[c.toUpperCase()] || c;
};

/** phần trên URL (slug hoặc mã, hoa/thường đều được) → mã gọi API */
export const categoryCodeFromParam = (param?: string | string[] | null): string => {
  const p = String(Array.isArray(param) ? param[0] : param ?? '');
  return SLUG_TO_CODE[p.toLowerCase()] || p.toUpperCase();
};
